<template>
  <generic-modal :title="$t('student')" ref="generic_modal">
    <form>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("names") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.first_name" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("surname") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.surname" />
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("id card number") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.id_card_number" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("birthdate") }}</label>
            <input type="date" class="input" v-model="meta.birthdate" />
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("email") }}</label>
            <div class="control">
              <input class="input" type="email" v-model="meta.email" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("phone") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.phone" />
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("address") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.address" />
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "StudentModal",
  components: { GenericModal },
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.first_name || !v.meta.surname || !v.meta.id_card_number;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    edit_modal(uuid) {
      let v = this;
      v.set_initial_state();

      get("/student", { uuid: uuid })
        .then((element) => {
          v.meta = element;
          v.$refs.generic_modal.show_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    save() {
      let v = this;
      if (!v.meta.uuid)
        put("/student", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      else
        post("/student", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        first_name: "",
        surname: "",
        id_card_number: "",
        birthdate: "",
        settings: {},
      };
      v.error = "";
      // v.uuid = "";
    },
    birthdate_changed(date) {
      let v = this;
      v.meta.birthdate = date;
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
